import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  AccountSwitchIcon,
  LogoIcon,
  LogoTextIcon,
} from "../../../components/icons";
import { ROUTES } from "../../../constants";
import { getActiveOrganization } from "../../../redux/selectors";
import AccountSelector from "./AccountSelector";

interface IFullLayoutHeaderProps {
  sidebarCollapsed: boolean;
  onToggleSidebar(): void;
}

const FullLayoutHeader: FC<IFullLayoutHeaderProps> = ({
  sidebarCollapsed,
  onToggleSidebar,
}) => {
  const [viewSelector, setViewSelector] = React.useState(false);
  const activeOrganization = useSelector(getActiveOrganization);

  return (
    <div className="h-12 relative bg-blue-dark flex items-center">
      <div className="flex items-center flex-row-reverse lg:flex-row">
        <div className="w-14 md:w-58 flex items-center ">
          <Link className="inline-flex items-center" to={ROUTES.DASHBOARD}>
            <div className="w-14 flex justify-center items-center">
              <LogoIcon color={["primary", "white"]} size={36} />
            </div>
            <LogoTextIcon
              color="white"
              className="hidden md:block"
              size={120}
            />
          </Link>
        </div>

        <div className="w-14 flex justify-center items-center">
          <i
            className="fa fa-bars text-lg text-white lg:hidden cursor-pointer"
            onClick={onToggleSidebar}
          />
        </div>
      </div>

      <div className="px-5 ml-auto" data-cy="open-org-menu">
        <div
          className="flex flex-row items-center space-x-8 font-bold text-white px-4 cursor-pointer"
          onClick={() => setViewSelector(true)}
          data-cy="open-account-selector"
        >
          {activeOrganization ? activeOrganization.name : "SUDONUM"}
          <AccountSwitchIcon className="ml-5" color="primary" />
        </div>
      </div>
      <div className="absolute w-full h-full left-0 top-0 z-10 shadow-lg pointer-events-none" />
      {viewSelector && (
        <AccountSelector onClose={() => setViewSelector(false)} />
      )}
    </div>
  );
};

export default FullLayoutHeader;
